import { take, call, put, takeLatest } from 'redux-saga/effects';
import authTypes, { storeLogin, storeToken, getStatusPasswordChange, storeCambioClave } from '../actions/auth.actions';
import api from "../api/api";

export function* requestOTP() {
    yield takeLatest(authTypes.REQUEST_OTP, takeLatestRequestOTP);
}

function* takeLatestRequestOTP({ payload }) {
    let store;

    try {
        const response = yield call(api.post, `/v1/login/otp`, payload);

        store = {
            username: payload.usuario,
            status: (response.data.result) ? 'request-otp' : 'not-authenticated',
            message: (response.data.result) ? 'Por favor ingrese el código de seguridad enviado a su correo' : 'Usuario y/o clave incorrectos'
        }

    } catch (error) {

        store = {
            status: 'not-authenticated',
            message: 'Usuario y/o clave incorrectos'
        }
    }

    yield put(storeLogin(store));
}

export function* sendLogin() {
    yield takeLatest(authTypes.SEND_LOGIN, takeLatestLogin);
}

export function* checkToken() {
    const payload = yield take(authTypes.CHECK_TOKEN);
    yield put(storeToken(payload));
}

function* takeLatestLogin({ payload }) {
    let store;

    try {
        const response = yield call(api.post, `/v1/login`, payload);
        localStorage.setItem('username', payload.usuario);

        if (response.data.token != null) {
            localStorage.setItem('token', response.data.token);
        }

        store = {
            username: payload.usuario,
            status: ((response.status === 200) && (response.data.token != null)) ? 'authenticated' : 'not-authenticated',
            message: (response.data.token != null) ? 'Usuario autenticado con éxito!' : 'Código de seguridad inválido'
        }

    } catch (error) {

        store = {
            status: 'not-authenticated',
            message: 'Usuario y/o clave incorrectos'
        }
    }

    yield put(storeLogin(store));
}

export function* getNewPassword() {
    yield takeLatest(authTypes.CHANGE_PASSWORD, takeLatestPassword);
}

function* takeLatestPassword({ payload }) {
    let response = yield call(api.post, `/v1/cambiar-clave`, { ...payload.values });
    yield put(getStatusPasswordChange(response.data));
}

export function* getRecoveryPassword() {
    yield takeLatest(authTypes.RECOVERY_PASSWORD, takeLatestRecoveryPassword);
}

function* takeLatestRecoveryPassword({ payload }) {
    let response = yield call(api.get, `/v1/recuperar-clave/${payload.values.email}`);
    yield put(getStatusPasswordChange(response.data));
}